import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import * as Http from "../../../http";
import { ProgressBar } from "react-bootstrap";
import * as Business from "../../../utils/business";
import { ErrorCode, FileExtension } from "../../../const";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import Alert from "sweetalert-react";

const chunkSize = 1048576 * 3;
let lstInterval = [];

function clearGetBatchUploadInterval(reportName) {
  lstInterval.forEach((id) => {
    clearInterval(id);
  });
  lstInterval = [];
}

function convertReportName(reportName) {
  return `IRRBB_${reportName}`;
}

const REQUIRED_FILES = [
  "BOND",
  "BRW",
  "CASA",
  "CC",
  "FS_SWAP",
  "FUTURE",
  "FX_FWD",
  "IN_BASE_INTEREST_RATE",
  "IN_BEHAVIORAL_MODEL",
  "IN_BEHAVIORAL_MODEL_MULTIPLIER",
  "IN_FX_RATE",
  "IN_INT_SHOCK_PARAMETER",
  "IN_INT_SHOCK_SIZE",
  "IN_REQUIRED_RESERVE",
  "IN_TIME_BUCKET",
  "IRSCCS",
  "LD",
  "MM",
  "OD",
  "PAYMENT_SCHEDULE",
  "REPO_RESO",
  "TD",
];

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progressValue: 0,
      errorCode: null,
      fileExtension: FileExtension.CSV,
      isMultipleFile: true,
      fileAccept: ".csv",
      reportName: "",
      reportDate: moment().format("YYYY-MM-DD"),
      noFileVal: "No file chosen...",
      classFileUpload: "file-upload",
      totalFiles: 0,
      listFileNameSelected: [],
      dicFileToBeUpload: {},
      currentStep: "form",
      hasResult: false,
      uploadErrors: [],
      showExistAlert: false,
      lstOutput: [],
      resultTable: null,
      isDragging: false,
    };
    this.setFileExtensionSelected = this.setFileExtensionSelected.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.onUploadFile = this.onUploadFile.bind(this);
    this.onUploadChunkFile = this.onUploadChunkFile.bind(this);
    this.onUploadChunkFileComplete = this.onUploadChunkFileComplete.bind(this);
    this.onGetBatchUploadingResponse =
      this.onGetBatchUploadingResponse.bind(this);
    this.handleUploadFileResponse = this.handleUploadFileResponse.bind(this);
    this.renderProcessingStep = this.renderProcessingStep.bind(this);
  }

  componentWillUnmount() {
    clearGetBatchUploadInterval();
  }

  setFileExtensionSelected = (fileExtension) => {
    const isMultipleFile = fileExtension === FileExtension.CSV;
    const fileAccept =
      fileExtension === FileExtension.XLSX
        ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        : ".csv";
    this.setState({
      fileExtension,
      isMultipleFile,
      fileAccept,
      noFileVal: "No file chosen...",
      classFileUpload: "file-upload",
      dicFileToBeUpload: {},
      listFileNameSelected: [],
      totalFiles: 0,
    });
  };

  processFiles = (fileList) => {
    if (!fileList || fileList.length === 0) return;
    const dicFileToBeUpload = {};
    const listFileNameSelected = [];
    let totalFiles = 0;
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      const totalCount =
        file.size % chunkSize === 0
          ? file.size / chunkSize
          : Math.floor(file.size / chunkSize) + 1;
      const fileID = uuidv4() + "." + file.name.split(".").pop();
      dicFileToBeUpload[file.name] = {
        counter: 1,
        fileName: file.name,
        fileToBeUpload: file,
        beginingOfTheChunk: 0,
        endOfTheChunk: chunkSize,
        fileGuid: fileID,
        fileSize: file.size,
        chunkCount: totalCount > 0 ? totalCount : 1,
        isUploaded: false,
      };
      listFileNameSelected.push(file.name);
      totalFiles++;
    }
    const noFileVal =
      totalFiles > 1 ? `${totalFiles} files chosen` : fileList[0].name;
    this.setState({
      classFileUpload: "file-upload active",
      listFileNameSelected,
      dicFileToBeUpload,
      noFileVal,
      totalFiles,
    });
  };

  onChangeFile = (e) => {
    this.processFiles(e.target ? e.target.files : null);
  };

  onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: false });
    if (this.state.progressValue > 0) return;
    this.processFiles(e.dataTransfer ? e.dataTransfer.files : null);
  };

  onValidate = () => {
    if (!this.state.reportName) {
      Business.showAlert({
        title: "Error",
        content: "You must enter value for Report Name.",
      });
      return false;
    }
    if (!new RegExp("^[A-Za-z0-9_]+$").test(this.state.reportName)) {
      Business.showAlert({
        title: "Error",
        content: "Report Name: allow only (a-z, A-Z, 0-9, _)",
      });
      return false;
    }
    if (!this.state.reportDate) {
      Business.showAlert({
        title: "Error",
        content: "You must enter value for Report Date.",
      });
      return false;
    }
    if (this.state.totalFiles === 0) {
      Business.showAlert({
        title: "Error",
        content: "You must select at least 1 file.",
      });
      return false;
    }
    return true;
  };

  onUploadFile = () => {
    if (!this.onValidate()) return;
    this.setState(
      { hasResult: false, progressValue: 5, currentStep: "processing" },
      () => {
        let { listFileNameSelected } = this.state;
        const fileUploading = listFileNameSelected.shift();
        this.setState({ fileUploading, listFileNameSelected }, () => {
          this.onUploadChunkFile();
        });
      },
    );
  };

  getCurrentFileUploadingInfo = () => {
    const { fileUploading, dicFileToBeUpload } = this.state;
    return dicFileToBeUpload.hasOwnProperty(fileUploading)
      ? dicFileToBeUpload[fileUploading]
      : {};
  };

  updateDicFileToBeUpload = (fileName, data, cb) => {
    const dicFileToBeUpload = this.state.dicFileToBeUpload;
    if (dicFileToBeUpload.hasOwnProperty(fileName)) {
      dicFileToBeUpload[fileName] = { ...dicFileToBeUpload[fileName], ...data };
    }
    this.setState({ dicFileToBeUpload }, () => {
      cb && cb();
    });
  };

  onUploadChunkFile = () => {
    try {
      let fileUploadingInfo = this.getCurrentFileUploadingInfo();
      const fileUploading = this.state.fileUploading;
      const currentCounter = fileUploadingInfo.counter;
      fileUploadingInfo["counter"] = currentCounter + 1;
      this.updateDicFileToBeUpload(
        fileUploading,
        fileUploadingInfo,
        async () => {
          fileUploadingInfo = this.getCurrentFileUploadingInfo();
          const {
            fileGuid,
            chunkCount,
            fileToBeUpload,
            beginingOfTheChunk,
            endOfTheChunk,
          } = fileUploadingInfo;
          if (currentCounter <= chunkCount) {
            const chunk = fileToBeUpload.slice(
              beginingOfTheChunk,
              endOfTheChunk,
            );
            Http.uploadChuckFile(chunk, {
              id: currentCounter,
              fileName: fileGuid,
            }).then(async (response) => {
              const isSuccess = response ? response.Success : false;
              if (isSuccess) {
                fileUploadingInfo["beginingOfTheChunk"] = endOfTheChunk;
                fileUploadingInfo["endOfTheChunk"] = endOfTheChunk + chunkSize;
                this.updateDicFileToBeUpload(
                  fileUploading,
                  fileUploadingInfo,
                  async () => {
                    fileUploadingInfo = this.getCurrentFileUploadingInfo();
                    if (currentCounter == chunkCount) {
                      fileUploadingInfo["isUploaded"] = true;
                      this.updateDicFileToBeUpload(
                        fileUploading,
                        fileUploadingInfo,
                        async () => {
                          let isAllFilesUploaded = true;
                          for (let fn in this.state.dicFileToBeUpload) {
                            if (
                              this.state.dicFileToBeUpload[fn]["isUploaded"] ===
                              false
                            ) {
                              isAllFilesUploaded = false;
                              break;
                            }
                          }
                          await this.onUploadChunkFileComplete(
                            isAllFilesUploaded,
                          );
                        },
                      );
                    } else {
                      const totalFiles = Object.keys(
                        this.state.dicFileToBeUpload,
                      ).length;
                      const doneFiles = Object.values(
                        this.state.dicFileToBeUpload,
                      ).filter((f) => f.isUploaded).length;
                      let percentage =
                        this.state.progressValue / totalFiles +
                        (currentCounter / chunkCount) * 100;
                      if (percentage > 99) percentage = 99;
                      this.setState({ progressValue: percentage }, () => {
                        this.onUploadChunkFile();
                      });
                    }
                  },
                );
              } else {
                this.handleUploadFileResponse(response);
              }
            });
          }
        },
      );
    } catch (error) {
      console.error(error);
    }
  };

  onUploadChunkFileComplete = async (isAllFilesUploaded) => {
    const { reportName, reportDate, fileExtension } = this.state;
    let fileUploadingInfo = this.getCurrentFileUploadingInfo();
    const { fileToBeUpload, fileGuid } = fileUploadingInfo;

    Http.uploadChuckFileComplete(
      fileGuid,
      {
        originFileName: fileToBeUpload ? fileToBeUpload.name : fileGuid,
        fileGuid: fileGuid,
        reportName: convertReportName(reportName),
        reportDate: reportDate,
        isAllFilesUploaded,
        fileExtension,
        isUploadOnly: "false",
        isUploadAndMerge: "false",
      },
      Business.COMPONENT.IRRBB,
    ).then((res) => {
      if (res && res.ErrorCode == ErrorCode.PendingUpload) {
        let { listFileNameSelected } = this.state;
        const fileUploading = listFileNameSelected.shift();
        this.setState({ fileUploading, listFileNameSelected }, () => {
          this.onUploadChunkFile();
        });
      } else {
        this.setState({ progressValue: 100 }, () => {
          this.handleUploadFileResponse(res);
          this.onGetBatchUploadingResponse();
        });
      }
    });
  };

  onGetBatchUploadingResponse = () => {
    const intervalId = setInterval(() => {
      Http.getBatchResult(
        this.state.reportDate,
        convertReportName(this.state.reportName),
      ).then((res) => {
        if (res) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            // still processing
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchUploadInterval();
          } else {
            clearGetBatchUploadInterval();
            this.handleUploadFileResponse(res);
          }
        }
      });
    }, 3000);
    lstInterval.push(intervalId);
  };

  handleUploadFileResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
      clearGetBatchUploadInterval();
    }
    if (res && res.Success) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        // waiting
      } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
        // nothing
      } else if (res.ErrorCode === ErrorCode.Exist) {
        this.setState({
          showExistAlert: true,
          currentStep: "form",
          progressValue: 0,
        });
      } else {
        this.setState({ hasResult: true });
        Http.getIrrbbResultTable(convertReportName(this.state.reportName)).then(
          (data) => {
            if (data && data.Success && data.Data) {
              this.setState({ resultTable: data.Data });
            }
          },
        );
        Http.getIrrbbOutputs(convertReportName(this.state.reportName)).then(
          (data) => {
            const lstOutput =
              data && data.Success && data.Data
                ? data.Data.map((o) => ({
                    output_type: o.output_type,
                    created: Business.convertToFullDate(o.created_time),
                  }))
                : [];
            this.setState({ lstOutput });
          },
        );
      }
    } else {
      if (res) {
        switch (res.ErrorCode) {
          case ErrorCode.PermissionDenie:
            Business.showAlert({
              title: "Error",
              content: "You are not permitted.",
            });
            break;
          case ErrorCode.Exist:
            this.setState({
              showExistAlert: true,
              currentStep: "form",
              progressValue: 0,
            });
            break;
          case ErrorCode.DataInvalid:
            Business.showAlert({
              title: "Error",
              content: res.Data || "Data invalid",
            });
            break;
          case ErrorCode.UnknowError:
            Business.showAlert({
              title: "Error",
              content: res.Data || "System Error",
            });
            break;
          default:
            Business.showAlert({
              title: "Error",
              content: "System Error (" + res.ErrorCode + ")",
            });
            break;
        }
      } else {
        Business.showAlert({ title: "Error", content: "Unknown Error" });
      }
      this.setState({ progressValue: 0, currentStep: "form" });
    }
  };

  renderProcessingStep = () => {
    const { progressValue, hasResult, errorCode, resultTable, reportName } =
      this.state;
    return (
      <div>
        <div className="header">
          <h4 className="title">
            <button
              type="button"
              className="btn btn-default btn-xs"
              style={{ marginRight: 12 }}
              onClick={() => {
                clearGetBatchUploadInterval();
                this.setState({
                  currentStep: "form",
                  progressValue: 0,
                  hasResult: false,
                  errorCode: null,
                  lstOutput: [],
                  resultTable: null,
                });
              }}
            >
              ← Quay lại
            </button>
            Kết quả xử lý IRRBB
          </h4>
        </div>
        <div className="content">
          {progressValue > 0 && progressValue < 100 && (
            <div style={{ marginBottom: 16 }}>
              <ProgressBar
                striped
                now={progressValue}
                label={"Đang upload " + progressValue.toFixed(1) + "%"}
              />
            </div>
          )}
          {progressValue >= 100 &&
            !hasResult &&
            (!errorCode || errorCode === ErrorCode.PendingBatchProcessing) && (
              <p style={{ textAlign: "center", color: "#888", marginTop: 20 }}>
                Hệ thống đang xử lý dữ liệu, vui lòng chờ...
              </p>
            )}
          {hasResult && (
            <div>
              <p
                style={{
                  color: "green",
                  fontWeight: 600,
                  fontSize: 15,
                  marginBottom: 16,
                }}
              >
                ✓ Xử lý hoàn tất - Báo cáo IRRBB đã được tính toán thành công
              </p>
              {resultTable && (
                <div style={{ marginBottom: 20 }}>
                  <h5
                    style={{
                      fontWeight: 700,
                      marginBottom: 10,
                      color: "#1a1a3e",
                    }}
                  >
                    {resultTable.title}
                  </h5>
                  <table className="table table-hover table-striped table-bordered">
                    <thead>
                      <tr>
                        {resultTable.headers.map((h, i) => (
                          <th
                            key={i}
                            style={{ textAlign: i > 0 ? "right" : "left" }}
                          >
                            {h || "Kịch bản"}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {resultTable.rows.map((row, i) => (
                        <tr key={i}>
                          {row.map((cell, j) => (
                            <td
                              key={j}
                              style={{ textAlign: j > 0 ? "right" : "left" }}
                            >
                              {typeof cell === "number"
                                ? cell.toLocaleString("vi-VN", {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })
                                : cell}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div style={{ marginTop: 8 }}>
                <button
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#FFE600",
                    borderColor: "#7F7E82",
                    borderRadius: "5px",
                    fontWeight: 600,
                    color: "#000",
                    marginRight: 10,
                  }}
                  onClick={() =>
                    Http.downloadIrrbbReport(convertReportName(reportName))
                  }
                >
                  <i className="pe-7s-download" /> Download Report
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => this.props.history.push("/irrbb/reports")}
                >
                  Xem danh sách báo cáo
                </button>
              </div>
            </div>
          )}
          {errorCode &&
            errorCode !== ErrorCode.PendingBatchProcessing &&
            !hasResult && (
              <p style={{ textAlign: "center", color: "red", marginTop: 20 }}>
                Xử lý thất bại (Error: {errorCode})
              </p>
            )}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="card upload-form-animated">
        <Alert
          title="Thông báo"
          show={this.state.showExistAlert}
          text="Tên báo cáo đã tồn tại trong hệ thống!"
          onConfirm={() => this.setState({ showExistAlert: false })}
        />
        {this.state.currentStep === "processing" ? (
          this.renderProcessingStep()
        ) : (
          <div>
            <div className="header">
              <h4 className="title">Upload file</h4>
              <button
                type="button"
                className="btn btn-default btn-sm"
                style={{
                  marginLeft: 12,
                  borderRadius: 20,
                  fontSize: 12,
                  padding: "4px 14px",
                  border: "1px solid #7F7E82",
                }}
                onClick={() => Http.downloadSampleFile("IRRBB.zip", "SAMPLE")}
              >
                <i className="pe-7s-download" style={{ marginRight: 4 }} />
                Download Template
              </button>
            </div>
            <div style={{ height: 10 }} />
            <div className="content" style={{ paddingBottom: 0 }}>
              {(() => {
                const checkedSet = new Set(
                  this.state.listFileNameSelected.map((f) =>
                    f.replace(/\.[^.]+$/, "").toUpperCase(),
                  ),
                );
                const checkedCount = REQUIRED_FILES.filter((r) =>
                  checkedSet.has(r),
                ).length;
                const allChecked = checkedCount === REQUIRED_FILES.length;
                return (
                  <div
                    style={{
                      display: "flex",
                      gap: 24,
                      alignItems: "flex-start",
                    }}
                  >
                    {/* ── LEFT: Upload Form ── */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <form>
                        <div className="form-group">
                          <label style={{ fontSize: 13, marginBottom: 4 }}>
                            File format
                          </label>
                          <div style={{ display: "flex", gap: 8 }}>
                            {Object.keys(FileExtension).map((ext, index) => (
                              <button
                                key={index}
                                type="button"
                                onClick={() =>
                                  this.setFileExtensionSelected(ext)
                                }
                                style={{
                                  padding: "5px 16px",
                                  borderRadius: 20,
                                  border:
                                    this.state.fileExtension === ext
                                      ? "2px solid #1a1a3e"
                                      : "1px solid #ccc",
                                  background:
                                    this.state.fileExtension === ext
                                      ? "#1a1a3e"
                                      : "#fff",
                                  color:
                                    this.state.fileExtension === ext
                                      ? "#fff"
                                      : "#333",
                                  fontWeight:
                                    this.state.fileExtension === ext
                                      ? 700
                                      : 400,
                                  fontSize: 13,
                                  cursor: "pointer",
                                }}
                              >
                                .{ext.toLowerCase()}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="form-group">
                          <label style={{ fontSize: 13, marginBottom: 4 }}>
                            Data file
                            <span style={{ color: "#C00F0C", marginLeft: 4 }}>
                              *
                            </span>
                          </label>
                          <div
                            onDragOver={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (this.state.progressValue === 0)
                                this.setState({ isDragging: true });
                            }}
                            onDragEnter={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (this.state.progressValue === 0)
                                this.setState({ isDragging: true });
                            }}
                            onDragLeave={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              this.setState({ isDragging: false });
                            }}
                            onDrop={this.onDrop}
                            onClick={() => {
                              if (this.state.progressValue === 0)
                                document.getElementById("chooseFile").click();
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              border: this.state.isDragging
                                ? "2px dashed #FFE600"
                                : "1px dashed #bbb",
                              borderRadius: 8,
                              padding: "10px 14px",
                              background: this.state.isDragging
                                ? "#fffef0"
                                : "#fafafa",
                              gap: 10,
                              cursor:
                                this.state.progressValue > 0
                                  ? "not-allowed"
                                  : "pointer",
                              transition: "border 0.15s, background 0.15s",
                            }}
                          >
                            <i
                              className="pe-7s-upload"
                              style={{
                                fontSize: 22,
                                color: this.state.isDragging
                                  ? "#FFE600"
                                  : "#1a1a3e",
                                transition: "color 0.15s",
                              }}
                            />
                            <div style={{ flex: 1 }}>
                              <div
                                style={{
                                  fontSize: 13,
                                  color:
                                    this.state.noFileVal === "No file chosen..."
                                      ? "#aaa"
                                      : "#1E1E1E",
                                  fontWeight:
                                    this.state.noFileVal === "No file chosen..."
                                      ? 400
                                      : 600,
                                }}
                              >
                                {this.state.isDragging
                                  ? "Thả file vào đây..."
                                  : this.state.noFileVal}
                              </div>
                              <div
                                style={{
                                  fontSize: 11,
                                  color: "#888",
                                  marginTop: 2,
                                }}
                              >
                                Kéo thả hoặc click để chọn nhiều file CSV
                                (Ctrl+A để chọn tất cả)
                              </div>
                            </div>
                            <label
                              htmlFor="chooseFile"
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                margin: 0,
                                padding: "6px 14px",
                                borderRadius: 6,
                                background:
                                  this.state.progressValue > 0
                                    ? "#eee"
                                    : "#FFE600",
                                color:
                                  this.state.progressValue > 0
                                    ? "#aaa"
                                    : "#1a1a3e",
                                fontSize: 12,
                                fontWeight: 600,
                                cursor:
                                  this.state.progressValue > 0
                                    ? "not-allowed"
                                    : "pointer",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Chọn file
                            </label>
                            <input
                              type="file"
                              multiple={this.state.isMultipleFile}
                              name="chooseFile"
                              id="chooseFile"
                              disabled={this.state.progressValue > 0}
                              accept={this.state.fileAccept}
                              onChange={this.onChangeFile}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>

                        <div style={{ display: "flex", gap: 16 }}>
                          <div className="form-group" style={{ flex: 2 }}>
                            <label style={{ fontSize: 13, marginBottom: 4 }}>
                              Report Name
                              <span style={{ color: "#C00F0C", marginLeft: 4 }}>
                                *
                              </span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="irrbbReportName"
                              value={this.state.reportName}
                              onChange={(e) =>
                                this.setState({ reportName: e.target.value })
                              }
                              style={{
                                border: "1px solid #D9D9D9",
                                borderRadius: 8,
                                height: 40,
                              }}
                            />
                          </div>
                          <div className="form-group" style={{ flex: 1 }}>
                            <label style={{ fontSize: 13, marginBottom: 4 }}>
                              Report Date
                              <span style={{ color: "#C00F0C", marginLeft: 4 }}>
                                *
                              </span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              id="irrbbReportDate"
                              min="2010-01-01"
                              max={moment(new Date(), "YYYY-MM-DD").format(
                                "YYYY-MM-DD",
                              )}
                              value={this.state.reportDate}
                              onChange={(e) =>
                                this.setState({ reportDate: e.target.value })
                              }
                              style={{
                                border: "1px solid #D9D9D9",
                                borderRadius: 8,
                                height: 40,
                              }}
                            />
                          </div>
                        </div>
                      </form>

                      <div style={{ marginTop: 8 }}>
                        <button
                          type="button"
                          disabled={this.state.progressValue > 0}
                          className="btn btn-primary upload-btn-modern"
                          style={{
                            backgroundColor: "#FFE600",
                            borderColor: "#7F7E82",
                            borderRadius: 8,
                            fontWeight: 700,
                            color: "#1a1a3e",
                            padding: "8px 28px",
                            fontSize: 14,
                          }}
                          onClick={this.onUploadFile}
                        >
                          <i
                            className="pe-7s-upload"
                            style={{ marginRight: 6, fontWeight: 700 }}
                          />
                          Upload
                        </button>
                      </div>
                    </div>

                    {/* ── RIGHT: Required Files Checklist ── */}
                    <div
                      style={{
                        width: 270,
                        flexShrink: 0,
                        border: "1px solid #e8e8e8",
                        borderRadius: 10,
                        overflow: "hidden",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                      }}
                    >
                      <div
                        style={{
                          background: "#1a1a3e",
                          padding: "10px 14px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: 13,
                          }}
                        >
                          Required Files
                        </span>
                        <span
                          style={{
                            background: "#FFE600",
                            color: "#1a1a3e",
                            borderRadius: 20,
                            padding: "2px 10px",
                            fontSize: 12,
                            fontWeight: 700,
                          }}
                        >
                          {checkedCount}/{REQUIRED_FILES.length}
                        </span>
                      </div>

                      <div style={{ height: 3, background: "#eee" }}>
                        <div
                          style={{
                            height: 3,
                            width: `${(checkedCount / REQUIRED_FILES.length) * 100}%`,
                            background: "#FFE600",
                            transition: "width 0.3s ease",
                          }}
                        />
                      </div>

                      <div style={{ maxHeight: 380, overflowY: "auto" }}>
                        {REQUIRED_FILES.map((reqFile, idx) => {
                          const checked = checkedSet.has(reqFile);
                          return (
                            <div
                              key={reqFile}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                padding: "6px 14px",
                                borderBottom: "1px solid #f2f2f2",
                                borderLeft: checked
                                  ? "3px solid #FFE600"
                                  : "3px solid transparent",
                                background: checked ? "#fffef5" : "#fff",
                                transition: "all 0.15s",
                              }}
                            >
                              <div
                                style={{
                                  width: 20,
                                  height: 20,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexShrink: 0,
                                }}
                              >
                                {checked ? (
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                  >
                                    <path
                                      d="M3 9.5L7.2 14L15 5"
                                      stroke="#FFE600"
                                      strokeWidth="2.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width="8"
                                    height="8"
                                    viewBox="0 0 8 8"
                                    fill="none"
                                  >
                                    <circle
                                      cx="4"
                                      cy="4"
                                      r="3"
                                      stroke="#d0d0d0"
                                      strokeWidth="1.5"
                                    />
                                  </svg>
                                )}
                              </div>
                              <span
                                style={{
                                  fontSize: 12,
                                  color: checked ? "#1a1a3e" : "#999",
                                  fontWeight: checked ? 700 : 400,
                                  flex: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {reqFile}.csv
                              </span>
                              {checked && (
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  style={{ flexShrink: 0 }}
                                >
                                  <circle cx="6" cy="6" r="5" fill="#FFE600" />
                                  <path
                                    d="M3.5 6L5.2 8L8.5 4"
                                    stroke="#1a1a3e"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </div>
                          );
                        })}
                      </div>

                      <div
                        style={{
                          padding: "8px 14px",
                          background: allChecked ? "#fffef5" : "#fafafa",
                          borderTop: "1px solid #eee",
                          borderLeft: allChecked
                            ? "3px solid #FFE600"
                            : "3px solid transparent",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <p
                          style={{
                            fontSize: 11,
                            color: allChecked ? "#1a1a3e" : "#aaa",
                            margin: 0,
                            fontWeight: allChecked ? 700 : 400,
                          }}
                        >
                          {allChecked
                            ? "Đã đủ file. Nhấn Upload để tiếp tục."
                            : `Còn thiếu ${REQUIRED_FILES.length - checkedCount} file.`}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(UploadFile);



// WEBPACK FOOTER //
// src/pages/IRRBB/UploadFile/index.js